__turbopack_context__.v({
  "description": "index-module__2chMbq__description",
  "title": "index-module__2chMbq__title",
  "wrapper": "index-module__2chMbq__wrapper",
});
